var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid_row"},_vm._l((_vm.cells),function({ legend, img },index){return _c('div',{key:index,staticClass:"grid_row__cell"},[_c('div',{staticClass:"grid_row__cell__image",domProps:{"innerHTML":_vm._s(img)}}),_c('div',{staticClass:"grid_row__cell__legend"},[_vm._v(" "+_vm._s(legend)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }